import React, { Component } from 'react';
import { Divider, Switch, Button, FormGroup, InputGroup } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class WebSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      siteTitle: 'SROFilter Silkroad Online Security Portal',
      discordWebhook: 'https://discord.com/api/webhooks/123456789/srofilter-alerts',
      registrationOpen: true,
      maintenanceMode: false,
      turnstileEnabled: true,
      googleAnalyticsId: 'G-Z988JD1KBW',
      saved: false
    };
  }

  handleSave = (e) => {
    e.preventDefault();
    this.setState({ saved: true });
    setTimeout(() => this.setState({ saved: false }), 3000);
  };

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          General Web Settings
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Configure portal SEO metadata, Discord webhooks, Cloudflare Turnstile bot protection, and user registration controls.
        </p>

        <Divider className="mb-4" />

        {this.state.saved && (
          <div className="alert alert-success py-2 mb-4" style={{ fontSize: '0.85rem' }}>
            Web Settings successfully saved!
          </div>
        )}

        <form onSubmit={this.handleSave}>
          <div className="row mb-3">
            <div className="col-md-6">
              <FormGroup label="Website Title Meta Tag" labelFor="site-title">
                <InputGroup
                  id="site-title"
                  value={this.state.siteTitle}
                  onChange={(e) => this.setState({ siteTitle: e.target.value })}
                />
              </FormGroup>
            </div>

            <div className="col-md-6">
              <FormGroup label="Google Analytics Tracking ID (GA4)" labelFor="ga-id">
                <InputGroup
                  id="ga-id"
                  value={this.state.googleAnalyticsId}
                  onChange={(e) => this.setState({ googleAnalyticsId: e.target.value })}
                />
              </FormGroup>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-12">
              <FormGroup label="Discord Webhook URL for Security Alerts" labelFor="discord-wh">
                <InputGroup
                  id="discord-wh"
                  value={this.state.discordWebhook}
                  onChange={(e) => this.setState({ discordWebhook: e.target.value })}
                />
              </FormGroup>
            </div>
          </div>

          <Divider className="my-4" />

          <h5 className="mb-3 font-weight-bold" style={{ color: '#182026' }}>Security & Portal Access Rules</h5>

          <div className="row mb-4">
            <div className="col-md-6">
              <Switch
                label="Allow New Player Account Registration"
                checked={this.state.registrationOpen}
                onChange={() => this.setState({ registrationOpen: !this.state.registrationOpen })}
              />
              <Switch
                label="Enable Cloudflare Turnstile Bot Protection"
                checked={this.state.turnstileEnabled}
                onChange={() => this.setState({ turnstileEnabled: !this.state.turnstileEnabled })}
              />
            </div>

            <div className="col-md-6">
              <Switch
                label="Enable Portal Maintenance Mode (Block Non-GMs)"
                checked={this.state.maintenanceMode}
                onChange={() => this.setState({ maintenanceMode: !this.state.maintenanceMode })}
              />
            </div>
          </div>

          <Button intent="primary" type="submit" icon="floppy-disk" small text="Save Web Settings" />
        </form>
      </SideMenuWrapper>
    );
  }
}
